import React from 'react';
import { ArrowLeftIcon, SparklesIcon } from './icons';

// Converts simple markdown to HTML: bold, and unordered lists.
const renderMarkdown = (text: string) => {
    let html = text
        // Bold: **text** -> <strong>text</strong>
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        // Unordered lists: * item -> <li>item</li>
        .replace(/^\s*\*[ \t](.*)$/gm, '<li>$1</li>');
        
    // Wrap list items in <ul>
    if (html.includes('<li>')) {
        html = `<ul>${html}</ul>`.replace(/<\/li>(\s*)<li>/g, '</li><li>');
    }

    // Replace newlines with <br> for paragraphs, but not inside lists
    html = html.replace(/<\/li><br \/>/g, '</li>')
               .replace(/\n/g, '<br />')
               .replace(/<\/ul><br \/>/g, '</ul>')
               .replace(/<br \/><br \/>/g, '<br />');


    return { __html: html };
};


interface SummaryViewProps {
  summary: string;
  error: string | null;
  onBack: () => void;
}

const SummaryView: React.FC<SummaryViewProps> = ({ summary, error, onBack }) => {
  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-8">
        <main className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6 md:p-10">
            <div className="flex justify-between items-center pb-4 mb-6">
                <div className="flex items-center gap-3">
                    <SparklesIcon className="h-7 w-7 text-brand-dark"/>
                    <h1 className="text-2xl font-bold text-slate-800">AI-Powered Summary</h1>
                </div>
                <button
                    onClick={onBack}
                    className="flex items-center gap-2 bg-slate-100 text-slate-700 font-semibold py-2 px-4 rounded-md hover:bg-slate-200 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-400"
                >
                    <ArrowLeftIcon />
                    Back to Full Report
                </button>
            </div>
            
            {error && (
                <div className="text-red-700 bg-red-100 p-4 rounded-md border border-red-200">
                    <p className="font-semibold">Analysis Failed</p>
                    <p className="text-sm">{error}</p>
                </div>
            )}

            {!error && summary && (
                <div 
                className="prose prose-base max-w-none text-slate-700 leading-relaxed prose-strong:text-slate-800 prose-ul:list-disc prose-ul:pl-5 prose-li:my-1" 
                dangerouslySetInnerHTML={renderMarkdown(summary)} 
                />
            )}
        </main>
    </div>
  );
};

export default SummaryView;